import { BooleanOperator } from 'src/enums/stowage/stowageRule/booleanOperator';
import { StowageRuleConsequenceType } from 'src/enums/stowage/stowageRule/stowageRuleConsequenceType';
import { StowageRuleId } from 'src/enums/stowage/stowageRule/stowageRuleId';
import { StowageRulePropertyLocation } from 'src/enums/stowage/stowageRule/stowageRulePropertyLocation';
import { StowageRulePropertyOperator } from 'src/enums/stowage/stowageRule/stowageRulePropertyOperator';
import { StowageRuleTestScope } from 'src/enums/stowage/stowageRule/stowageRuleTestScope';
import { StowageRuleBM } from 'src/types/BusinessModel/Stowage/StowageRule/StowageRuleBM';

export const propyleneOxideSoftRule = {
    id: StowageRuleId.PropyleneOxideSoftRule,
    name: 'IBC 15.8 Propylene Oxide Soft Rule: a cargo with IBC requirement 15.8 is stowed in any tank.',
    lastUpdatedUtc: '2014-05-15T13:24:00',
    condition: {
        operator: BooleanOperator.AND,
        children: [
            {
                leaf: {
                    properties: [
                        {
                            name: 'Product category specific and operational requirements',
                            fieldPath: 'cargo.product.category.ibcSpecificRequirements',
                            type: 'array',
                            location: StowageRulePropertyLocation.Tank,
                        },
                        {
                            name: 'IBC chapter 15.8',
                            type: 'string',
                            referenceValue: 'IBC-15.8',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Tank,
                    operator: StowageRulePropertyOperator.Contains,
                },
            },
            {
                leaf: {
                    properties: [
                        {
                            name: 'Stowed weight',
                            fieldPath: 'getCargoStowedWeight',
                            type: 'number',
                            location: StowageRulePropertyLocation.NA,
                        },
                        {
                            name: 'Reference value',
                            type: 'number',
                            referenceValue: '0',
                            location: StowageRulePropertyLocation.NA,
                        },
                    ],
                    scope: StowageRuleTestScope.Cargo,
                    operator: StowageRulePropertyOperator.IsGreaterThan,
                },
            },
        ],
    },
    consequence: {
        type: StowageRuleConsequenceType.SoftRule,
        parameter: 'Please check your Propylene Oxide manual and COF. Adjust fill ratio as appropriate.',
    },
} as StowageRuleBM;
